import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import Plot from "react-plotly.js";
import React, {useEffect, useState} from "react";
import {
  getBoxplotAnalyze,
  getConfusionMatrix,
  getFeatureImportancePlot,
  getDataBalancerPlot,
  getHistogramplot,
  getScatterplotAnalyze,
  getScatterplotTime,
  getAFSBarChart,
  getScatterplotAFS,
  getErrorModelPlot,
  getErrorModelScatterPlot,
} from "../utils/plotting";

function Plotting(props) {
  const [plotData, setPlotData] = useState([]);
  const [plotLayout, setPlotLayout] = useState({});

  const theme = useTheme();
  const { t } = useTranslation();

  const plotGenerators = {
    boxAnalyze: getBoxplotAnalyze,
    scatterAnalyze: getScatterplotAnalyze,
    confusionMatrixVal: getConfusionMatrix,
    confusionMatrixTrain: getConfusionMatrix,
    confusionMatrixTest: getConfusionMatrix,
    scatterTime: getScatterplotTime,
    histogram: getHistogramplot,
    featureImportance: getFeatureImportancePlot,
    dataBalancer: getDataBalancerPlot,
    AFSHeatmap: getAFSBarChart,
    AFSScatter: getScatterplotAFS,
    errorModel: getErrorModelPlot,
    errorScatter: getErrorModelScatterPlot,
    // Add more plot types and their corresponding generator functions
  };

  const generatePlot = () => {
    const { type } = props;
    const plotGenerator = plotGenerators[type];
    if (plotGenerator) {
      const plot = plotGenerator(props, t, theme);
      setPlotLayout(plot[1]);
      setPlotData(plot[0]);
    }
  };
  const config = {
    responsive: true,
    toImageButtonOptions: {
      format: "svg",
      filename: `plot-${props.type}-${new Date().toISOString()}`,
      height: 800,
      width: 1200,
      scale: 1,
    },
  };

  useEffect(() => {
    generatePlot();
  }, [props.type, props.runData, props.selectedTargetIndex,  props.currentTarget,
    props.timestamps,
    props.targetSeries, theme, t]);

  return (
    <>
      {plotData.length > 0 ? (
        <div
          style={{
            maxHeight: "700px",
            overflowY: "auto",
            overflowX: "hidden",
            width: "100%",
            maxWidth: "100%",
          }}
        >
          <Plot
            data={plotData}
            layout={plotLayout}
            config={config}
            style={{ width: "100%", height: "100%" }}
            useResizeHandler
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default Plotting;
